// extracted by mini-css-extract-plugin
export default {"loginForm":"auth_loginForm__CLTZ8","password_container":"auth_password_container__pxph5","passwordToggle":"auth_passwordToggle__8WHnH","error":"auth_error__bNH4v"};